/**
 * Close the main menu on click outside
 */
export default function closeMainNavOnOutsideClick() {
  const navigationStateInput = document.querySelector('#navigation-state');
  const wrapNavigation = document.querySelector('.wrap--navigation');

  if (!wrapNavigation || !navigationStateInput) return;

  wrapNavigation.addEventListener('click', (event) => {
    if (!event.target.closest('#mainNavigation')) navigationStateInput.checked = false;
  });
}
